import { IPaginatedGeneratorWithTokensShallow } from "@novel/shared/interfaces/TokenMetadata";
import { NovelVendorSubReducer } from "@vendor-portal/redux/vendorTypedRedux";

export interface IGeneratorsReducerState extends IPaginatedGeneratorWithTokensShallow {
    isLoading: boolean;
}

const initialState: IGeneratorsReducerState = {
    isLoading: true,
    totalCount: 0,
    pageSize: 0,
    pageNumber: 0,
    totalPages: 0,
    data: [],
};

export const generatorsReducer: NovelVendorSubReducer<IGeneratorsReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_GENERATORS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_GENERATORS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_GENERATORS": {
            return {
                ...state,
                totalCount: action.payload.paginatedGenerators.totalCount,
                pageSize: action.payload.paginatedGenerators.pageSize,
                pageNumber: action.payload.paginatedGenerators.pageNumber,
                totalPages: action.payload.paginatedGenerators.totalPages,
                data: action.payload.paginatedGenerators.data,
                isLoading: false,
            };
        }

        default:
            return state;
    }
};
